import CommonPersonalSettingHome from '../../../common/pages/secure/PersonalSettingHome'

class PersonalSettingHome extends CommonPersonalSettingHome {
  constructor (props) {
    super(props)
    this.state = {}
    this.userRoleUrl = 'company_admin'
  }
}

export default PersonalSettingHome



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/PersonalSettingHome.js